export function getFormLanguage() {
  return document.querySelector('html').getAttribute('lang').substring(0, 2);
}
